(function(){
  function init(root){
    var els=(root||document).querySelectorAll('.rl-r:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target)}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  function tilt(){
    if(window.matchMedia('(hover:none)').matches)return;
    document.querySelectorAll('[data-rl-tilt]').forEach(function(el){
      el.addEventListener('mousemove',function(ev){var r=el.getBoundingClientRect(),x=(ev.clientX-r.left)/r.width-.5,y=(ev.clientY-r.top)/r.height-.5;el.style.transform='perspective(800px) rotateY('+(x*10)+'deg) rotateX('+(-y*10)+'deg) translateY(-4px)'});
      el.addEventListener('mouseleave',function(){el.style.transform=''});
    });
    var st=document.querySelector('.rl-stage');
    if(st){var hero=st.closest('.rl-hero');hero.addEventListener('mousemove',function(ev){var x=ev.clientX/window.innerWidth-.5,y=ev.clientY/window.innerHeight-.5;st.style.transform='translate('+(x*-18)+'px,'+(y*-18)+'px)'})}
  }
  function copy(){
    document.querySelectorAll('[data-rl-copy]').forEach(function(b){b.addEventListener('click',function(){var c=b.getAttribute('data-rl-copy');(navigator.clipboard?navigator.clipboard.writeText(c):Promise.reject()).then(function(){b.textContent='¡Copiado!';setTimeout(function(){b.textContent='Copiar'},1800)}).catch(function(){})})});
  }
  function go(){init();tilt();copy()}
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',function(e){init(e.target);tilt();copy()});
})();
